module.exports = __webpack_public_path__ + "static/logo-white-48490f5845456887a58b5eede0fbfaae.png";